module.exports = __webpack_public_path__ + "static/anonymous-b59778a4215605dd61d149b2ae6f0cd5.jpg";